import { prodDomain } from '@/src/config/consts';

export default (props, vars) => window.location.host === prodDomain;
